import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import { Row, Table } from "antd";
import { toJS, runInAction, action } from "mobx";
import TableText from "../../table/TableText";
import { calculation } from "@/method";

const totalIndex = [];

@inject("store")
@observer
class App extends Component {
  state = {
    user: {},
  };
  componentDidMount() {
    this.props.store.menu
      .getUserInfo()
      .then((user) => {
        this.setState({ user });
      })
      .catch((err) => {
        console.error(err);
      });
  }

  @action
  onChange = (name, value, i) => {
    let data = toJS(this.props.store.kpifollow.platform);
    data[i][name] = value;
    this.props.store.kpifollow.platform = data;
  };

  render() {
    const { data, loading, platform } = this.props.store.kpifollow;
    const columns = [
      {
        title: "餐饮预订平台",
        dataIndex: `name`,
        key: `name`,
        width: 150,
        align: "center",
        render: (text, record, index) => {
          const props = {
            text,
            index,
            type: "text",
            name: `name`,
            onChange: this.onChange,
            totalIndex,
          };
          return <TableText data={props} />;
        },
      },
      {
        title: "差评关键词",
        dataIndex: `order`,
        key: `order`,
        width: 150,
        align: "center",
        render: (text, record, index) => {
          const props = {
            text,
            index,
            type: "input",
            name: `order`,
            onChange: this.onChange,
            totalIndex,
          };
          return <TableText data={props} />;
        },
      },
      {
        title: "MTD点评数量",
        dataIndex: `comment`,
        key: `comment`,
        width: 150,
        align: "center",
        render: (text, record, index) => {
          const props = {
            text,
            index,
            type: "inputNumber",
            name: `comment`,
            onChange: this.onChange,
            totalIndex,
          };
          return <TableText data={props} />;
        },
      },
      {
        title: "MTD分数",
        dataIndex: `fraction`,
        key: `fraction`,
        width: 150,
        align: "center",
        render: (text, record, index) => {
          const props = {
            text,
            index,
            type: "inputNumber",
            name: `fraction`,
            onChange: this.onChange,
            totalIndex,
          };
          return <TableText data={props} />;
        },
      },
      {
        title: "YTD目标",
        dataIndex: `total`,
        key: `total`,
        width: 150,
        align: "center",
        render: (text, record, index) => {
          const props = {
            text,
            index,
            type: (this.state.user.email || "").includes("admin")
              ? "inputNumber"
              : "number",
            name: `total`,
            onChange: this.onChange,
            totalIndex,
          };
          return <TableText data={props} />;
        },
      },
    ];

    return (
      <Table
        columns={columns}
        dataSource={toJS(platform)}
        size="middle"
        bordered
        pagination={false}
        className="content"
        rowKey={"r.name"}
      />
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/otherHeadquartersForms/kpifollow/Table4.js